
const digest = '5f80e41fb763698b2695d5546d1b2c26d4406e711a5c150ceb419813549055b9';
const classes = {"wrapper":"_wrapper_1l5as_1","title":"_title_1l5as_8"};
const css = `._wrapper_1l5as_1 {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

._title_1l5as_8 {
  display: flex;
  flex-direction: row;
  font-family: Poppins, sans-serif;
  color: #212357;
  font-weight: 600;
  font-size: 18px;
  padding-right: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  